import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Button from '../common/Button';
import { fadeIn } from '../../utils/gsapAnimations';
import { useContent } from '../../context/ContentContext';


function ReturnPolicy() {
  const sectionRef = useRef(null);
    const { content, loading, error } = useContent();
  

  useEffect(() => {
    fadeIn(sectionRef.current, 0.3);
  }, []);

  return (
    <div ref={sectionRef} className="py-12 px-4 text-center">
      <h2 className="text-2xl font-lora font-semibold text-burgundy mb-4">Our Return Policy</h2>
      <p className="text-poppins mb-4 max-w-2xl mx-auto">
      {content.returnPolicy?.description || 'We want you  to be completely satisfied with your purchase. If you are not satisfied, you may return any unworn, unwashed, or defective merchandise within 30 days of the original purchase date for a full refund or exchange.'}
      </p>
      <Link to="/contact">
        <Button>Contact Support</Button>
      </Link>
    </div>
  );
}

export default ReturnPolicy;